import "./index.scss";

import { Box } from "@mui/material";

export default function CapsuleText({ text, className }: { text: string; className?: string }) {
  return <Box className={`capsule-text ${className}`}>{text}</Box>;
}
